import { Applemusic, Applepodcasts, Cashapp, Discord, Email, Etsy, Facebook, Github, Google, Instagram, Linkedin, Pinterest, Snapchat, Spotify, Threads, Tiktok, Twitch, Twitter, Venmo, Website, Whatsapp, Youtube } from './socialIcons.js';

var Social = {
  Applemusic: Applemusic,
  Applepodcasts: Applepodcasts,
  Cashapp: Cashapp,
  Discord: Discord,
  Email: Email,
  Etsy: Etsy,
  Facebook: Facebook,
  Github: Github,
  Google: Google,
  Instagram: Instagram,
  Linkedin: Linkedin,
  Pinterest: Pinterest,
  Snapchat: Snapchat,
  Spotify: Spotify,
  Threads: Threads,
  Tiktok: Tiktok,
  Twitch: Twitch,
  Twitter: Twitter,
  Venmo: Venmo,
  Website: Website,
  Whatsapp: Whatsapp,
  Youtube: Youtube
};

export { Social as default };
//# sourceMappingURL=index.js.map
